import React from 'react';
import HomepageLayout from 'components/Common/Layouts/HomepageLayout';

const DataSetViewPage: React.FC = () => {
  const dataset_dashboard = process.env.REACT_APP_DATASET_LINK!;
  return (
    <HomepageLayout title='Datasets' >
      <div className='os-iframe'>
        <iframe className='os-iframe' src={dataset_dashboard}></iframe>
      </div>
    </HomepageLayout>
  );
};

export default DataSetViewPage;
